import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { LdsComponentsModule } from '@liberty-financial/ng-components';
import { AgpSharedModule } from '@liberty-financial/agp-shared';

import { PipesModule } from '@shared/pipes/pipes.module';
import { SummaryFieldModule } from '@shared/components/summary-field/summary-field.module';

import { AdviceFeeComponent } from './advice-fee/advice-fee.component';
import { AdviceFeeDisplayComponent } from './advice-fee-display/advice-fee-display.component';
import { HasCreditAdviceFeePipe } from './pipes/has-credit-advice-fee.pipe';
import { HasCreditAssistanceFeePipe } from './pipes/has-credit-assistance-fee.pipe';
import { CreditAdviceFeeLabelPipe } from './pipes/credit-advice-fee-label.pipe';

@NgModule({
  declarations: [
    AdviceFeeComponent,
    AdviceFeeDisplayComponent,
    HasCreditAdviceFeePipe,
    HasCreditAssistanceFeePipe,
    CreditAdviceFeeLabelPipe
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LdsComponentsModule,
    AgpSharedModule,
    PipesModule,
    SummaryFieldModule
  ],
  exports: [
    AdviceFeeComponent,
    AdviceFeeDisplayComponent,
    HasCreditAdviceFeePipe,
    HasCreditAssistanceFeePipe
  ]
})
export class CreditAdviceFeeModule {} 